<template>
  <div
    v-if="isVisible"
    class="spb-past-due-banner"
    data-cy="spb-past-due-banner"
  >
    <i class="fas fa-triangle-exclamation spb-past-due-banner__icon" />
    <div class="spb-past-due-banner__text">
      Past due — {{ formattedAmount }} owed across overdue installments.
    </div>
  </div>
</template>

<script setup lang="ts">
import currency from "serviceshift-ui/shared/src/filters/currency";
import { computed, onMounted } from "vue";
import { trackEvent } from "@/lib/pendo";

import type { Invoice } from "@/typings/invoice";

const props = defineProps<{
  invoice: Invoice;
}>();

const isVisible = computed<boolean>(() => {
  const block = props.invoice.progress_billing;
  if (!block) return false;
  if (block.payment_status === "voided") return false;
  return block.past_due === true;
});

const formattedAmount = computed<string>(() =>
  currency((props.invoice.progress_billing?.past_due_amount_cents ?? 0) / 100)
);

onMounted(() => {
  if (!isVisible.value) return;
  trackEvent("spb_past_due_banner_viewed", {
    invoice_id: props.invoice.invoice_id
  });
});
</script>
